import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { getApiHeader } from '../../../../../utlis/commonfunctions';
import swal from 'sweetalert';
import SimpleReactValidator from 'simple-react-validator';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import AddPlanHead from './AddPlanHead';
import DropIn from 'braintree-web-drop-in-react';
import { Backdrop, CircularProgress } from '@mui/material';
import Loader from './loader';
import done from '../../../../../assets/images/done.png';

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
const isValidNo = /^[0-9]*$/;

const Payment = ({ nextStep, prevStep, handleDataStepOne, setActivationSuccessMsg, setActivationSuccessData,activationSubmitData, commonSession, selectedPlanData,planDetails, userAccountData,setStep }) => {


    var pay_status = selectedPlanData?.data?.payment_status;
    if(pay_status === 1){
        if(activationSubmitData?.data?.plan_details?.amount === 0){
            var pay_status = 0;
        }
    }

    if(activationSubmitData?.data?.plan_details?.payment_status === 1){
        var pay_status = 1;
    }

    
    console.log("pay status",pay_status);


    const [clientToken, setClientToken] = useState('');
    const [loading, setLoading] = useState(false);

    const instanceRef = useRef(null);
    const [agreedToTerms, setAgreedToTerms] = useState(false);

    const apiUrl = process.env.REACT_APP_API_URL;
    const apiKey = process.env.REACT_APP_API_TOKEN;


    const [anyError, setAnyError] = useState(false);
    const [payment_status, setPayment_status] = useState(pay_status);
    const [retailer_type, setRetailer_type] = useState('retail');

    const [defaultCard, setdefaultCard] = useState([]);
    const [existingCard, setExistingCard] = useState(0);


    const handleCheckboxChange = (event) => {
        setAgreedToTerms(event.target.checked);
    };

    useEffect(() => {


        if (payment_status === 1) {
            setLoading(true);
            fetchDefaultCard();
        }
        console.log("activationSubmitData---------->",activationSubmitData);
        console.log("selectedPlanData_____>",selectedPlanData);
        console.log("planDetails--------->",planDetails);

    }, []);


    

    const fetchDefaultCard = async () => {
        const headers=await getApiHeader();
        try {
            const response = await axios.get(`${apiUrl}retailer-default-card`,
                {
                    headers: headers,
                }
            );


            if (response?.status === 200) {
                const paymentMethods = response?.data?.data?.payment_methods;
                if (typeof paymentMethods === "object" && !Array.isArray(paymentMethods) && paymentMethods !== null) {
                    setdefaultCard(paymentMethods);
                    setExistingCard(1);
                    setLoading(false);
                } else {
                    fetchToken();
                }
            } else {
                fetchToken();
            }
            // if(response?.status===200){
            //     if(response?.data?.data?.payment_methods != undefined){
            //         setdefaultCard(response.data.data.payment_methods);
            //         setExistingCard(1);
            //         setLoading(false);
            //     }
            // }else{
            //     fetchToken();
            // }

        } catch (error) {

            fetchToken();
           
        }
    };



    const handlePaymentSubmit = async () => {

        if(payment_status === 1 && existingCard===0){
            if (!instanceRef.current) return;
        }
       

        try {
            setLoading(true);


            let nonce = null;
            if (instanceRef.current && existingCard===0) {
                const paymentMethod = await instanceRef.current.requestPaymentMethod();
                nonce = paymentMethod.nonce;
            }

            const headers = await getApiHeader();

            const post_data = {
                SessionId: commonSession,
                credit_status_ptc: "NO",
                ...(nonce && { payment_method_nonce: nonce }),
                default_Card:existingCard
            };

            const response = await axios.post(`${apiUrl}add_a_wme_mobile_plan/activateV2`, post_data , { headers: headers });

            setActivationSuccessMsg(response.data.message?.activation_message)
            setActivationSuccessData(response.data.data)
            nextStep()

        } catch (error) {
            console.log("error--->", error);
            if (error.name === "DropinError") {
                swal("Error in Payment", error.message, "warning");
            } else if (error.response?.data?.message) {
                swal("", error.response.data.message,'warning').then(() => {
                    //window.location.reload();
                    setStep(0)
                });
            } else {
                swal("Unexpected error", "Please try again", 'error');
            }
        } finally {
            setLoading(false);
        }
    };

    const fetchToken = async () => {
        setLoading(true)
        const headers=await getApiHeader();
        try {
            const response = await axios.get(`${apiUrl}add_a_wme_mobile_plan/get-client-token`,
                {
                    headers: headers,
                }
            );
            const clientToken = response.data.data.clientToken;

            setClientToken(clientToken);
            setLoading(false)
        } catch (error) {
            setLoading(false)
        }
    };
    return (
        <div>
            <DashboardLayout>
                <DashboardNavbar />
                <AddPlanHead />
           
                <div className="formbold-main-wrapper add-plan-wrapper">
                    <div className="formbold-form-wrapper add-plan-form pos-rel">

                        {loading === true && (
                            <Loader />
                        )}

                        <h6>Confirmation</h6>
                        <hr />
                        <br />

                        <div className="ad-mb-result add-mb-payment">

                            <div className="col-lg-7">
                                <div className="col-lg-6 add-mb-6">
                                    <div className="details-block cd-block">
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Customer Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                <td>{activationSubmitData.data.customer_details.name}</td>
                                                </tr>
                                                <tr>
                                                    <td >{activationSubmitData.data.customer_details.email}</td>
                                                </tr>
                                                <tr>
                                                    <td >DOB: {userAccountData.user_dob}</td>
                                                </tr>

                                                <tr>
                                                    <td  
                                                     style={{
                                                        wordWrap: 'break-word',
                                                        wordBreak: 'break-word',
                                                        whiteSpace: 'normal',
                                                        maxWidth: '300px',
                                                        overflow: 'hidden', 
                                                    }}>   
                                                  Address: {activationSubmitData.data.customer_details.address}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="details-block pl-block">
                                        <table className="text-left">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Plan Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>

                                                <td>
                                                            {activationSubmitData.data.plan_details?.plan_amount >activationSubmitData.data.plan_details?.plan_sell_amount ? (
                                                                <>
                                                                    Telsim <span style={{ textDecoration: "line-through" }}> ${activationSubmitData.data.plan_details?.plan_amount}</span>
                                                                    <span>  ${activationSubmitData.data.plan_details?.plan_sell_amount}</span> Prepaid Pack
                                                                </>
                                                            ) : (
                                                                activationSubmitData.data.plan_details?.offerName
                                                            )}
                                                        </td>



                                               
                                               
                                               
                                                {/* <td >{activationSubmitData.data.plan_details.offerName}</td> */}
                                                </tr>
                                                <tr>
                                                    <td >{activationSubmitData.data.plan_details.gb_data} GB Data</td>
                                                </tr>
                                                <tr>
                                                    <td >{activationSubmitData.data.plan_details.validity} Days Validity</td>
                                                </tr>
                                                {activationSubmitData.data.plan_details.idd_free60_included && (
                                                <tr>
                                                 <td> Free IDD 60 Minutes pack included </td>
                                                </tr>
                                                )}
                                                <tr><td><br/></td></tr>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                        Billing 
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td >
                                                        Plan Amount: <span className="add-mb-tt-pay">
                                                            {activationSubmitData.data.plan_details.plan_amount > activationSubmitData.data.plan_details?.plan_sell_amount ? (
                                                                <>
                                                                    <span style={{ textDecoration: "line-through" }}>${activationSubmitData.data.plan_details.plan_amount === "49.90" ? "45.00" : Number(activationSubmitData.data.plan_details.plan_amount).toFixed(2)}</span>
                                                                    <span>  ${activationSubmitData.data.plan_details?.plan_sell_amount}</span>
                                                                </>
                                                            ) : (
                                                               <span>${activationSubmitData.data.plan_details?.plan_amount}</span> 
                                                            )}
                                                        </span>
                                                    </td>

                                                </tr>
                                                {activationSubmitData.data.plan_details.is_bolt !== 5 ? (
                                                <tr> 
                                                    <td >

                                                        Retailer Price: <span className="add-mb-tt-pay">${activationSubmitData.data.plan_details.discount_amount}</span>

                                                    </td>
                                                </tr>  
                                                ):''}
                                            
                                                <tr>
                                                    <td >

                                                        Wallet Credit Used: <span className="add-mb-tt-pay">${Number(activationSubmitData.data.plan_details.wallet_used_amount).toFixed(2)}
                                                        </span>

                                                    </td>
                                                </tr>  

                                                <tr>   
                                                    <td >
                                                        Payable Amount: <span className="add-mb-tt-pay">${payment_status === 1 ? (
                                                            <>
                                                            {activationSubmitData.data.plan_details.amount}
                                                            </>
                                                            ):0}
                                                          
                                                            </span>
                                                    </td>

                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>

                                </div>


                                <div className="col-lg-6 add-mb-6">
                                    <div className="details-block cd-block">
                                        <table >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            SIM Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>SIM : {activationSubmitData.data.sim_details.sim}</td>
                                                </tr>
                                                <tr>
                                                     <td> {selectedPlanData.data.plan_type === "free_credit" ? "Credit SIM" : "Default Activation" } </td>
                                                </tr>
                                                {activationSubmitData.data.sim_details.reference_number &&
                                                    (
                                                        <tr>
                                                            <td><p>Reference Number : {activationSubmitData.data.sim_details.reference_number}</p></td>
                                                        </tr>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                    <div className="details-block pl-block">
                                        <table className="text-left">
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <label className="formbold-form-label formbold-form-label-2">
                                                            Mobile Details
                                                        </label>
                                                    </td>
                                                </tr>
                                                <tr>
                                                <td>Type : {activationSubmitData.data.mobile_details.mobile_selection_type === "new" ? "New Activation" : "PortIn"}  </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        Number: {activationSubmitData.data.mobile_details.mobile_number} 
                                                        <span style={{ color: '#e20e75' }}>  Verified</span>
                                                    </td>
                                                </tr>
                                  
                                                {activationSubmitData.data.mobile_details.mobile_selection_type === "portin" && (
                                                    <>
                                                        <tr>
                                                            <td >
                                                                PortIn Provide : {activationSubmitData.data.mobile_details.mobile_provider}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td >
                                                                PortIn Type :  {activationSubmitData.data.mobile_details.port_service_type}
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                           {activationSubmitData.data.mobile_details.port_service_type === "Pre-paid"
                                                            ? (<td > PortIn DOB : {activationSubmitData.data.mobile_details.port_dob}</td>) : (<td>Account Number: {activationSubmitData.data.mobile_details.port_account_id} </td>) }
                                                        </tr>

                                                        {activationSubmitData.data.mobile_details.port_in_authority_date && (
                                                            <tr>
                                                                <td >
                                                                    PortIn Authority Date :  {activationSubmitData.data.mobile_details.port_in_authority_date}
                                                                </td>
                                                            </tr>

                                                        )}
                                                        
                                                    </>
                                                )}

                                            </tbody>
                                        </table>
                                    </div>

                           
                                </div>

                                {payment_status === 1 && (
                                     <div className="col-lg-12 noPayment noheight">
                                        
                                        <p><i className="fa fa-info"></i> Please check the activation details and confirm activation</p>
                                        
                                    </div>
                                )}
                               

                            </div>
                            {/*----------------- Payment section ---------------*/}

                           
                            <div className="col-lg-5 payment-secion">
                                {payment_status === 1 && (

                                    <div className="pay-btree-block">
                                        <span className="amount-mention">*All amounts are mentioned in AUD </span>

                                        {(defaultCard && existingCard === 1) ?

                                            <div className="defaultCard col-lg-12">
                                                <div className="defaultCardBox">
                                                    <p>Paying With Card</p>
                                                    <ul className="defaultCardDetails">
                                                        <li>
                                                            <img src={defaultCard.imageUrl} />
                                                        </li>
                                                        <li>
                                                            <span>Ending In {defaultCard.last4}</span>
                                                            <span>{defaultCard.cardType}</span>
                                                        </li>
                                                        <li>
                                                            <img src={done} />
                                                        </li>
                                                    </ul>
                                                </div>
                                            </div>
                                            :

                                            <>
                                           
                                            {clientToken && (
                                                <DropIn
                                                    options={{ authorization: clientToken }}
                                                    onInstance={(instance) => (instanceRef.current = instance)}
                                                />
                                            )}

                                            </>
                                        }

                                    </div>

                                )}




                                {payment_status === 0 && (
                                <div className="noPayment">
                                    <p><i className="fa fa-info"></i></p>
                                    <p>Please check the activation details and confirm activation</p>
                                    
                                </div>
                                )}
                                <div className="pay-btree-block">
                                    <label className="check-box add-mb-accept-pay">
                                        I have read and accept the <a target="_blank" href='https://www.telsim.com.au/website-terms-conditions/'>Terms & Conditions</a>, the Acceptable Use Policy,
                                        the <a target="_blank" href='https://www.telsim.com.au/website-privacy-policy/'>Privacy Policy</a> for my Telsim service.
                                        <input type="checkbox" required="" id="agreeTerms" checked={agreedToTerms}
                                            onChange={handleCheckboxChange} title="Please check and agree to the terms and conditions" />
                                        <span className="tick"></span>
                                    </label>
                                </div>
                        </div>

                    </div>


                    <br />
                    <div className="button-container add-mb-button-container">
                        <button className="button btn btn-danger" onClick={prevStep}>
                            Back
                        </button>
                        <button
                            className="button btn btn-danger ad-mb-button-next"
                            disabled={!agreedToTerms || loading}
                            onClick={async () => {
                                const confirmResult = await swal({
                                    title: "Confirm Activation",
                                    text: "Are you sure you want to activate this plan?",
                                    icon: "warning",
                                    buttons: true,
                                    dangerMode: true,
                                });

                                if (confirmResult) {
                                    handlePaymentSubmit();
                                }
                            }}
                        >
                            Confirm & Activate
                        </button>
                    </div>
                    </div>
                </div>
            </DashboardLayout>
        </div>
    );
};

export default Payment;
